// Display-only role relabels keyed by partner. Internal Role_Type / shift.role
// values must never be touched — the backend, config grouping, and shape-of-day
// matching all depend on canonical names like "Waiter".
const ROLE_DISPLAY_OVERRIDES = {
  moto: { Waiter: 'Team Member' },
};

export const displayRole = (role, partnerId) => {
  if (!role || !partnerId) return role;
  const map = ROLE_DISPLAY_OVERRIDES[partnerId];
  return (map && map[role]) || role;
};

// Rewrite a composite "A+B+C" shape-of-day label so each segment is relabelled.
export const displayCompositeRole = (label, partnerId) => {
  if (!label || !partnerId) return label;
  if (!label.includes('+')) return displayRole(label, partnerId);
  return label
    .split('+')
    .map((p) => displayRole(p.trim(), partnerId))
    .join('+');
};
